 import { useState, useEffect } from "react";
 import { useNavigate, useParams } from "react-router-dom";
 import axios from "api/baseurl";
 import { toast } from "react-toastify";
 import "react-toastify/dist/ReactToastify.css";
 import CircularProgress from "@mui/material/CircularProgress";
 import Box from "@mui/material/Box";
 import Card from "@mui/material/Card";
 import Grid from "@mui/material/Grid";
 import Modal from "@mui/material/Modal";
 import MDBox from "components/MDBox";
 import MDTypography from "components/MDTypography";
 import MDButton from "components/MDButton";
 import MDInput from "components/MDInput";
 import TextField from "@mui/material/TextField";
 import MenuItem from "@mui/material/MenuItem";
 import InputAdornment from "@mui/material/InputAdornment";
 
 import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
 import DashboardNavbar from "examples/Navbars/DashboardNavbar";
 import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
 import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
 import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
 import { Country, State, City } from "country-state-city";
 import { formatDateDDMMYYYY } from "utils/dateFormatter";
 import { keyframes } from "@mui/system";
import Pagination from "@mui/material/Pagination";
import { Checkbox, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";

import EmailIcon from "@mui/icons-material/Email";
import CallIcon from "@mui/icons-material/Call";
import DescriptionIcon from "@mui/icons-material/Description"; // for Progress Note
import Tooltip from "@mui/material/Tooltip"; // optional for hover text
import DoctorPhoneCallModal from "./DoctorPhoneCallModal"; 


 
 
     function TotalDoctorsWorking({ isOpen, onRequestClose, id}) {
   const loginData = JSON.parse(localStorage.getItem("loginData"));
  const userid = loginData?.userid;

  const [openModal, setOpenModal] = useState(false);
  const [selectedDealerId, setSelectedDealerId] = useState(null);
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
const [openDelearModal, setOpenDelearModal] = useState(false);
const [selectedDelearId, setSelectedDelearId] = useState(null);
const [selectedDelearName, setSelectedDelearName] = useState(null);
const [currentPage, setCurrentPage] = useState(0);
const [totalPages, setTotalPages] = useState(0);
  const [error, setError] = useState("");
  const [devicename, setDevicename] = useState("");
  const [device_id, setDevice_id] = useState("");
  const [devices, setDevices] = useState([]);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
const [user, setUser] = useState(null);
 


    const [coordinatorList, setCoordinatorList] = useState([]);  
     // Progress Note Modal State
  const [openProgressModal, setOpenProgressModal] = useState(false);
  const [selectedDoctorId, setSelectedDoctorId] = useState(null);
  const [progressNote, setProgressNote] = useState({
    id:"",
    ccid:userid,
    doctorid:"",
    notes:"",
    

  });

   const [openSwitchModalState, setOpenSwitchModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [openCallModal, setOpenCallModal] = useState(false);
const [callNumber, setCallNumber] = useState("");
  const navigate = useNavigate();

  
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
const openSwitchModal = (id) => {
    setSelectedUserId(id);
    setOpenSwitchModal(true);
  };

  const handleSwitchClose = () => {
    setOpenSwitchModal(false);
    setSelectedUserId(null);
  };
   const handleSwitchUser = async () => {
    try {
      setLoading(true);
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;
     const response = await axios.post(
      `/api/switch-to-admin/${selectedUserId}`,
      {}, 
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        const loginData = {
        userid: decryptedData.userid,
        username: decryptedData.username,
        role: decryptedData.role,
        token: decryptedData.token,
        authorities: decryptedData.authorities || [],
      };

      // ✅ Store in localStorage
      localStorage.setItem("loginData", JSON.stringify(loginData));

      console.log("After update:", JSON.parse(localStorage.getItem("loginData")));

      toast.success(`Role updated to ${decryptedData.role} for ${decryptedData.username}`);

      navigate('/Admindasboard');
       setTimeout(() => {
          window.location.reload();
        }, 100);
    }
  } catch (error) {
    console.error("Error switching user:", error);
    toast.error("Switch failed. Please try again.");
  } finally {
    setLoading(false);
  }
};
  const fetchcarecoordinators = async (pageNumber = 1) => {
      setLoading(true);

      try {
        const secretKey = await fetchSecretKey();
        const token = JSON.parse(localStorage.getItem("loginData"))?.token;
  
        if (!token) throw new Error("Authentication token not found.");
  
        const response = await axios.get(`/api/dashboard/doctor/doctor_registration/cstatus/${userid}`, {
          params: { page: Math.max(0, pageNumber - 1) },    
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
  
        if (response.status === 200) {
          const decryptedData = decryptBody(response.data, secretKey);
          setCoordinatorList(decryptedData.content || []);
          setCurrentPage(decryptedData.number + 1);
          setTotalPages(decryptedData.totalPages);
          console.log("Decrypted Response Data:", decryptedData);        }
      } catch (error) {
        console.error("Error fetching Care Coordinators:", error);
        // toast.error("Failed to fetch device types.");
      } finally {
        setLoading(false); 
      }
    };
    

  useEffect(() => {
    fetchcarecoordinators(); 
   }, []);


 const handleOpenProgressModal = (doctorid) => {
  setSelectedDoctorId(doctorid);

  setProgressNote((prev) => ({
    ...prev,
    doctorid: doctorid,
    ccid: userid,     // Care coordinator ID from login
  }));

  setOpenProgressModal(true);
};


const openPhoneCall = (country, phone) => {
  const formatted = `${country}${phone}`;
  setCallNumber(formatted);
  setOpenCallModal(true);
};
 
    const handleSubmit = async (e) => {
     
     e.preventDefault();
   
    if (!progressNote.notes.trim()) {
    setError("Progress note is required.");
    return;
  }

  if (progressNote.notes.trim().length < 3) {
    setError("Progress note must be at least 3 characters.");
    return;
  }

    setError(""); // clear error
     setLoading(true);
       try {
         
         const secretKey = await fetchSecretKey();
       
         
         const rawPayload = {
               id: "",
              ccid: progressNote.ccid,
              doctorid: progressNote.doctorid,
              notes: progressNote.notes,
             };
     
         console.log("Raw Payload Before Encryption:", rawPayload); 
     
         const encryptedData = encryptBody(rawPayload, secretKey);
     
         console.log("Encrypted Payload:", encryptedData);
     
         const token = JSON.parse(localStorage.getItem("loginData")).token;
     
         // Register Dealer
         const response = await axios.post("/api/doctornotes/create", encryptedData, {
           headers: {
             "Content-Type": "application/json",
             Authorization: `Bearer ${token}`,
           },
         });
     
        if (response.status === 200) {
  const decryptedResponse = decryptBody(response.data, secretKey);
  console.log("Decrypted Response:", decryptedResponse);

  // Backend returns an object, not { success: true }
  if (!decryptedResponse || !decryptedResponse.id) {
    toast.error("Failed to save progress notes.");
    return;
  }

  toast.success("Progress Note added successfully!");

  // Close modal
  handleCloseProgressModal();

  // Optionally refresh list:
  // fetchProgressNotes();

} else {
  toast.error("Failed to save progress notes.");
}

      } catch (error) {
     console.error("Registration Error:", error);
   
     let errorMessage = "Registration failed"; // default message
   
     if (error.response) {
       const data = error.response.data;
   
       // ✅ If backend sends a structured JSON with a 'message' field
       if (typeof data === "object" && data.message) {
         errorMessage = data.message;
       } 
       // ✅ If backend sends a plain text message
       else if (typeof data === "string") {
         errorMessage = data;
       }
     } 
     // ✅ For network or other unexpected errors
     else if (error.message) {
       errorMessage = error.message;
     }
   
     toast.error(errorMessage);
   } finally {
     setLoading(false);
   }
     };


     
  const handleOpenDelearModal = (DelearId,DelearName) => {
    setSelectedDelearId(DelearId);
    setSelectedDelearName(DelearName);

    setOpenDelearModal(true);
  };
  
  const handleCloseDelearModal = () => {
    setOpenDelearModal(false);
    setSelectedDelearId(null);
    setSelectedDelearName(null);

  };
  const handlePageChange = (_, pageNumber) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    if (searchTerm) {
      setCurrentPage(); 
    }
  }, [searchTerm]);
  
  useEffect(() => {
    if (searchTerm) {
      searchData(currentPage); 
    } else {
      fetchcarecoordinators(currentPage);
    }
  }, [searchTerm, currentPage]);
  
 

  const handleCloseProgressModal = () => {
    setOpenProgressModal(false);
    setSelectedDoctorId(null);
    setProgressNote({
  id: "",
  ccid: userid,
  doctorid: "",
  notes: "",
});
     setError(""); // reset validation error
  };

  const searchData = async (pageNumber = 1) => {
    setLoading(true);
     
      
       console.log("Search term before API call:", searchTerm);
       try {
         setLoading(true);
         const secretKey = await fetchSecretKey();
         const token = JSON.parse(localStorage.getItem("loginData")).token;
     
         const requestBody = encryptBody({ccid:userid, searchTerm: searchTerm }, secretKey);
   
       const response = await axios.post(`/api/patientregistration/search`, requestBody, {
        params: { page: Math.max(0, pageNumber - 1) },  
            headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        console.log("Decrypted Search Response:", decryptedData); 
       setCoordinatorList(decryptedData.content || []);
        setCurrentPage(decryptedData.number + 1);
        setTotalPages(decryptedData.totalPages);
      }
    } catch (error) {
      console.error("Error searching :", error);
    } finally {
      setLoading(false);
    }
  };
   const spinAnimation = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  `;
  const dotPositions = [
    { top: "5%", left: "50%" },
    { top: "20%", left: "80%" },
    { top: "50%", left: "95%" },
    { top: "80%", left: "80%" },
    { top: "95%", left: "50%" },
    { top: "80%", left: "20%" },
    { top: "50%", left: "5%" },
    { top: "20%", left: "20%" },
  ];

  const handleOpenEditModal = async (id) => {
          setSelectedId(id);
          setOpenEditModal(true);
    };
    const handleCloseEditModal = () => {
      setOpenEditModal(false);
      setSelectedId(null);
      fetchcarecoordinators(); 
    };
    const handleOpenDeleteModal = (id) => {
      setSelectedId(id);
      setDeleteModal(true);
    };
    const handleDelete = async (e) => {
      e.preventDefault();
      setLoading(true);
      try {
        const secretKey = await fetchSecretKey();
        const token = JSON.parse(localStorage.getItem("loginData"))?.token;
    
        const encryptedData = encryptBody({ id: selectedId }, secretKey);
    
        const response = await axios.post("/api/patientregistration/delete", encryptedData, {
          headers: { "Content-Type": "text/plain", Authorization: `Bearer ${token}` },
        });
    
        if (response.status === 200) {
          const decryptedResponse = decryptBody(response.data, secretKey);
          if (!decryptedResponse || !decryptedResponse.id) {
            throw new Error("Decryption failed or invalid response.");
          }
    
          toast.success(decryptedResponse.message || "Patient Profile deleted successfully!");
    
          setDeleteModal(false); 
          fetchcarecoordinators();
        }
      } catch (error) {
        toast.error(error.message || "Failed to delete Doctor Profile.");
      } finally {
        setLoading(false);
      }
    };
    const handleRowClick = (dealer) => {
      const { email, userid } = dealer?.basicprofile || {};
      const { role } = dealer || {};
    
      // Step 1: Get existing loginData
      let loginData = JSON.parse(localStorage.getItem("loginData")) || {};
    
      console.log("Before update:", loginData);
    
      // Step 2: Update fields if values are present
      if (email && userid && role) {
        loginData.username = email;
        loginData.userid = userid;
        loginData.role = role;
    
        // Step 3: Save updated loginData back to localStorage
        localStorage.setItem("loginData", JSON.stringify(loginData));
    
        console.log("After update:", JSON.parse(localStorage.getItem("loginData")));
    
        toast.success(`Role updated to ${role} for ${email}`);
        navigate('/Admindasboard');
        setTimeout(() => {
          window.location.reload();
        }, 100);
      } else {
        console.log("Missing required fields in  object.");
      }
    };

      useEffect(() => {
           if (isOpen) {
             //fetchCareCoordinatorDetails();
           }
         }, [isOpen]);

    const handleToggle = async (id, currentStatus) => {
      const updatedStatus = !currentStatus;
     setCoordinatorList((prevList) =>
    prevList.map((item) =>
      item.id === id
        ? {
            ...item,
            status: updatedStatus, // directly on item
          }
        : item
    )
  );
    
      try {
        const secretKey = await fetchSecretKey();
        const token = JSON.parse(localStorage.getItem("loginData"))?.token;
        console.log("Raw data before encryption (status update):", { id, status: updatedStatus });
    
        const encryptedData = encryptBody(
          { id, status: updatedStatus },
          secretKey
        );
    
        const response = await axios.post(
          "/api/doctorregistration/update",
          encryptedData,
          {
            headers: {
              "Content-Type": "text/plain",
              Authorization: `Bearer ${token}`,
            },
          }
        );
    
        if (response.status === 200) {
          const decryptedResponse = decryptBody(response.data, secretKey);
          if (!decryptedResponse || !decryptedResponse.id) {
            throw new Error("Decryption failed or invalid response.");
          }
    
          toast.success("Status updated successfully!");
         
        }
      } catch (error) {
        
       
    
        toast.error(error.message || "Failed to update status.");
        console.error("Toggle error:", error);
      }
    };
 
   return (
     <DashboardLayout>
       <DashboardNavbar />
 
       {loading && (
         <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
           <CircularProgress />
         </Box>
       )}
 
       <Modal open={isOpen}  onClose={onRequestClose}>
       <MDBox
   display="flex"
   justifyContent="center"
   alignItems="center"
   height="100vh"
   p={2}
 >        <Card
   sx={{
     width: { xl: "84%", sm: "90%", md: "800px" },
    padding: 3,
    margin: "auto",
    marginTop: "5vh",
    maxHeight: "90vh",
   
    position: "relative"  // important for icon position
   }}
 > 

 {/* Close Icon */}
<IconButton
  onClick={onRequestClose}
  sx={{
    position: "absolute",
    top: 10,
    right: 10,
    color: "black",
    backgroundColor: "#f0f0f0",
    borderRadius: "50%",
    "&:hover": { backgroundColor: "#e0e0e0" }
  }}
>
  <CloseIcon />
</IconButton>

 
            <MDBox pt={2} pb={2} px={3}>
               <MDTypography variant="h5" mb={0.5} textAlign="center">
                 Doctor Working Profile Details:
               </MDTypography>
               <MDBox sx={{ overflowX: "auto", width: "100%" }}>
                <TableContainer component={Paper} sx={{ maxHeight: "70vh",
      overflowY: "auto", mt: 3, border: "1px solid #ddd", borderRadius: "8px", boxShadow: "2px 4px 10px rgba(0,0,0,0.1)" }}>
                  <Table sx={{ tableLayout: "fixed", width: "100%", borderCollapse: "collapse" }}>
                    
                    {/* Table Head */}
                    <TableHead>
              
              
              
                      <TableRow sx={{ backgroundColor: "#2e7faeff"}}>
          {[ "Name", "Doctor Type","NMC Registered Number", "Year Of Registration", "Contact" ,"Actions"].map((header, index) => (
            <TableCell
              key={index}
              sx={{
                fontWeight: "bold",
                border: "1px solid #ddd",
                textAlign: "center",
                padding: "7px",

                 minWidth:
      index === 0 ? "200px" : 
      index === 1 ? "130px" :   // ⬅ Increase DOB column size
      "150px",

    width:
      index === 0 ? "315px" :
      index === 1 ? "130px" :   // ⬅ Increase DOB column size
      "170px",
              
                              whiteSpace: "nowrap",  // Prevent breaking into multiple lines
                              overflow: "hidden",
                              textOverflow: "ellipsis",
              }}
            >
              {header}
            </TableCell>
          ))}

       
  </TableRow>
                    
              
                          <TableBody>
        {coordinatorList.length > 0 ? (
          coordinatorList.map((dealer, index) => (
           <TableRow
  key={index}

>
           
               <TableCell sx={{ border: "1px solid #ddd",
    textAlign: "center",
    padding: "12px",

    whiteSpace: "normal",
    wordBreak: "break-word",
    overflow: "visible", }}>
                {dealer.firstname} {dealer.lastname}
              </TableCell>
                  <TableCell sx={{ border: "1px solid #ddd",
    textAlign: "center",
    padding: "12px",

    whiteSpace: "normal",
    // wordBreak: "break-word",
    overflow: "visible", }}>
                {dealer?.doctorType}
               
              </TableCell> 
              <TableCell sx={{ border: "1px solid #ddd",
    textAlign: "center",
    padding: "12px",

    whiteSpace: "normal",
    wordBreak: "break-word",
    overflow: "visible", }}>
                {dealer?.nmcRegisteredNumber}
               
              </TableCell> <TableCell sx={{ border: "1px solid #ddd",
    textAlign: "center",
    padding: "12px",

    whiteSpace: "normal",
    wordBreak: "break-word",
    overflow: "visible", }}>
                {dealer?.yearOfRegistration}
               
              </TableCell>
               {/* <TableCell sx={{ border: "1px solid #ddd",
    textAlign: "center",
    padding: "12px",

    whiteSpace: "normal",
    wordBreak: "break-word",
    overflow: "visible",}}>
                {dealer?.verificationstatus}
               
              </TableCell> */}
 <TableCell sx={{ border: "1px solid #ddd",
    textAlign: "center",
    padding: "12px",

    whiteSpace: "normal",
    wordBreak: "break-word",
    overflow: "visible", }}>
                {dealer?.phonecountrycode} {dealer?.phoneNumber}
               
              </TableCell>
                {/* <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px", width: "120px" }}>
                {dealer.age}
               
              </TableCell> */}
              {/* <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px", width: "120px" }}>
                {dealer.dob}
               
              </TableCell> */}
              {/* <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px", width: "120px" }}>
                {dealer.gender}
              </TableCell>
               <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px", width: "120px" }}>
                {dealer.martialStatus}
              </TableCell>
                <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px", width: "120px" }}>
                {dealer.certificationvalidtill}
              </TableCell>
                <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px", width: "120px" }}>
                {dealer.dob}
              </TableCell>
                <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px", width: "120px" }}>
                {dealer.age}
              </TableCell> */}
                {/* <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px", width: "120px" }}>
                {dealer.locationid}
              </TableCell> */}

             

              
                

               <TableCell sx={{textAlign: "center",border: "1px solid #ddd"}}>
                  <Box sx={{display: "flex", alignItems: "center", justifyContent: "center", gap: 1   }}>
 
    {/* Call */}
    <Tooltip title="Call">
      <IconButton
        color="success"
        size="small"
         onClick={(e) => {
      e.stopPropagation();
      setCallNumber(`${dealer?.phonecountrycode}${dealer?.phoneNumber}`);
      setSelectedDoctorId(dealer.id);  // for progress note
      setOpenCallModal(true);           // open your PhoneCallModal
    }}
      >
        <CallIcon />
      </IconButton>
    </Tooltip>

     {/* Progress Note */}
    <Tooltip title="Progress Note">
      <IconButton
        color="info"
        size="small"
        onClick={(e) => {
          e.stopPropagation(); // prevent row click
          handleOpenProgressModal(dealer.id);
        }}
      >
        <DescriptionIcon />
      </IconButton>
    </Tooltip>

    {/* Email */}
    <Tooltip title="Send Email">
      <IconButton
        color="primary"
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          window.location.href = `mailto:${dealer?.email || ""}`;
        }}
      >
        <EmailIcon />
      </IconButton>
    </Tooltip>

                   </Box>

               </TableCell>
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={8} align="center" sx={{ border: "1px solid #ddd", padding: "12px", fontStyle: "italic", color: "gray" }}>
              No Data Available.
            </TableCell>
          </TableRow>
        )}
      </TableBody>
                    </TableHead>
                    <Box mt={2} display="flex" justifyContent="center">
                        <Pagination
                          count={totalPages}
                          page={currentPage}
                          onChange={handlePageChange}
                          color="success"
                           sx={{
                  "& .MuiPaginationItem-root": {
                    borderRadius: "4px",
                    color: "#2e7faeff",          // Text color
                    borderColor: "#2e7faeff",    // Border color if outlined
                  },
                  "& .MuiPaginationItem-root.Mui-selected": {
                    backgroundColor: "#2e7faeff", // Selected background
                    color: "#fff",                 // Selected text color
                  },
                  "& .MuiPaginationItem-root:hover": {
                    backgroundColor: "#2e7faeff33", // Slight hover effect
                  },
                }}
                        />
                      </Box>
                  </Table>
                </TableContainer>
              </MDBox>
              
                 <Grid container spacing={3}>
  {/* Profile Photo Upload */}
 <Grid item xs={12} style={{ textAlign: "center" }}>

 </Grid>
 
                      
                   
 

   
 
       
 
 
 
 
 
 
                 
                 </Grid>
                 
                 <MDBox mt={3} textAlign="center">
                  
                  
                 </MDBox>
              
             </MDBox>
           </Card>
         </MDBox>
       </Modal>

       {openCallModal && (
  <DoctorPhoneCallModal
    open={openCallModal}
    onClose={() => setOpenCallModal(false)}
    phoneNumber={callNumber}
    doctorid={selectedDoctorId}
    userid={userid}
    fetchProgressNotes={fetchcarecoordinators} // refresh list after saving note
  />
)}

       {/* Progress Note Modal */}
     <Modal open={openProgressModal} onClose={handleCloseProgressModal}>
             <MDBox display="flex" justifyContent="center" alignItems="center" height="100vh" p={2}>
               <Card sx={{ width: 
                 { xs: "95%", sm: "90%", md: "500px" },
                  padding: 3, maxHeight: "80vh",       // <-- limit height
             overflowY: "auto",
                   }}>
                 <MDTypography variant="h6" mb={2} textAlign="center">
                   Add Progress Note
                 </MDTypography>
               <form onSubmit={handleSubmit}>
                 <MDInput
                   multiline
                   rows={6}
                   value={progressNote.notes}
                   onChange={(e) =>
       setProgressNote((prev) => ({
         ...prev,
         notes: e.target.value,
       }))
     }
     
                   placeholder="Enter progress note..."
                   fullWidth
                   error={Boolean(error)}
                 />
                 
             {error && (
               <MDTypography variant="caption" color="error">
                 {error}
               </MDTypography>
             )}
                 <Box mt={2} display="flex" justifyContent="flex-end" gap={1} pb={1}>
                   <MDButton 
                  sx={{
         background: "#9E9E9E",
         color: "#fff",
         "&:hover": {
           background: "#9E9E9E", // darker shade on hover
         },
       }} onClick={handleCloseProgressModal}>
                     Cancel
                   </MDButton>
                   <MDButton 
                   variant="contained"
                   type="submit"
                  
                 //   onClick={handleSaveProgressNote}
                     sx={{
         backgroundColor: "#2e7fae !important",
         color: "#fff", 
         "&:hover": {
           backgroundColor:"#2e7fae !important", 
         },
       }} 
                   >
                     Save
                   </MDButton>
                  
                 </Box>
                  </form>
               </Card>
             </MDBox>
           </Modal>


     </DashboardLayout>
   );
 }
 
 export default TotalDoctorsWorking;
 